<template>
  <div class="m-loading" v-if="loadingType !== false">
    <template v-if="loadingType === -1">
      <div class="m-loading-text">{{ notText }}</div>
    </template>
    <template v-if="loadingType === 0">
      <div class="m-loading-text">{{ notMore }}</div>
    </template>
    <template v-if="loadingType === 1">
      <div class="m-loading-text" v-if="loadingText">{{ loadingText }}</div>
      <Loading class="m-loading-ico" />
    </template>
  </div>
</template>

<script>
import Loading from "./Loading";
export default {
  data() {
    return {};
  },
  props: {
    loadingType: {
      default: 1
    },
    notText: {
      default: "当前没有内容"
    },
    notMore: {
      default: "没有更多了"
    },
    loadingText: {
      default: ""
    }
  },
  components: { Loading },
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
.m-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  height: 36px;
  box-sizing: border-box;
}
.m-loading-text {
  font-size: 12px;
  color: #999;
  & + .m-loading-ico {
    margin-left: 10px;
  }
}
.m-loading-ico {
  opacity: 0.8;
}
</style>
